import { useEffect } from "react";
import styled from "styled-components";

import BIMClassesFilter from "./BIMClassesFilter";
import BrandsFilter from "./BrandsFilter";
import CountriesFilter from "./CountriesFilter";
import * as S from "./styled";
import useFilters from "./useFilters";
import useProductSearch from "../../../../../../clients/productSearch/useProductSearch";
import useBrandsOfUser from "../../../../../../clients/users/useBrandsOfUser";

export default function ProductFilters() {
    const [filters, set, limit] = useFilters();

    const _brands = useBrandsOfUser();

    useEffect(
        () => {
            set("_brands", _brands);
        },
        [_brands],
    );

    const discovery = useProductSearch({ _brands });

    if (!_brands) return undefined;

    function ca() {
        set("bimClasses", []);
        set("brands", []);
        set("countries", []);
    }

    const hasFilters = Boolean(filters?.bimClasses?.length || filters?.brands?.length || filters?.countries?.length);

    return (
        <Styled onSubmit={ (event) => event.preventDefault() }>
            <BrandsFilter
                disabled={ "brands" in limit }
                discovery={ discovery.data?.searchProducts?.enumerateBrands }
                onChange={ (brands) => set("brands", brands) }
                value={ filters.brands ?? [] }
            />
            <BIMClassesFilter
                disabled={ "bimClasses" in limit }
                discovery={ discovery.data?.searchProducts?.enumerateBimClasses }
                onChange={ (bimClasses) => set("bimClasses", bimClasses) }
                value={ filters.bimClasses ?? [] }
            />
            <CountriesFilter
                disabled={ "countries" in limit }
                discovery={ discovery.data?.searchProducts?.enumerateCountries }
                onChange={ (countries) => set("countries", countries) }
                value={ filters.countries ?? [] }
            />
            { hasFilters && <S.Button onClick={ ca } type="button">[x] clear all</S.Button> }
        </Styled>
    );
}

const Styled = styled.form`
    align-items: flex-end;
    box-sizing: border-box;
    display: flex;
    flex: none;
    flex-direction: column;
    gap: 24px;
    height: fit-content;
`;
